import $ from 'jquery';

import webApp from './webApp';

const user = {
  get isLoggedIn() {
    return Boolean( this._isLoggedIn );
  },

  set isLoggedIn( newStatus ) {
    const oldStatus = this._isLoggedIn;
    this._isLoggedIn = newStatus;

    if ( oldStatus !== newStatus ) {
      webApp.hooks.doAction( 'login_status_changed', newStatus );
    }
  },

  isEditor: false,
  isAdmin: false,
};

user.init = function() {
  // Whenever connectivity changes, re-check login status
  webApp.hooks.addAction( 'network_status_changed', 'asmag_user', updateStatusFromServer );

  return updateStatusFromServer();
};

export default user;

// ---------------------------------------------------------------------------
//
// Private functions
//
// ---------------------------------------------------------------------------

function updateStatusFromServer() {

  if ( !webApp.networkStatus ) {
    user.isEditor = false;
    user.isAdmin = false;
    user.isLoggedIn = false;
    return Promise.resolve();
  }

  const xhr = $.ajax( {
    url: webApp.env.site_url + '/asmag/web-app/userinfo',
    type: 'GET',
    dataType: 'json',
    timeout: 15000,
    success: function(data) {
      if (data.code == 0 && data.result) {
        user.isEditor = data.result.isEditor;
        user.isAdmin = data.result.isAdmin;
        user.isLoggedIn = data.result.isLoggedIn;
      }
      else {
        user.isEditor = false;
        user.isAdmin = false;
        user.isLoggedIn = false;
      }
    },
    error: function() {
      user.isEditor = false;
      user.isAdmin = false;
      user.isLoggedIn = false;
    }
  } );

  return Promise.resolve( xhr );
}
